import React from "react"

import { Fade } from "../fadeWrapper/fadeWrapper"

import { container, teamPhoto } from "./teamPhoto.module.sass"

import teamPhoto1 from "./teamPhoto1.png"
import teamPhoto2 from "./teamPhoto2.png"
import teamPhoto3 from "./teamPhoto3.png"
import teamPhoto4 from "./teamPhoto4.png"
import teamPhoto5 from "./teamPhoto5.png"
import teamPhoto6 from "./teamPhoto6.png"
import teamPhoto7 from "./teamPhoto7.png"
import teamPhoto8 from "./teamPhoto8.png"
import teamPhoto9 from "./teamPhoto9.png"
import teamPhoto10 from "./teamPhoto10.png"

const TeamPhoto = () => {
  return (
    <Fade>
      <div className={container}>
        <img className={teamPhoto} src={teamPhoto1} alt="team-1" />
        <img className={teamPhoto} src={teamPhoto2} alt="team-2" />
        <img className={teamPhoto} src={teamPhoto3} alt="team-3" />
        <img className={teamPhoto} src={teamPhoto4} alt="team-4" />
        <img className={teamPhoto} src={teamPhoto5} alt="team-5" />
        <img className={teamPhoto} src={teamPhoto6} alt="team-6" />
        <img className={teamPhoto} src={teamPhoto7} alt="team-7" />
        <img className={teamPhoto} src={teamPhoto8} alt="team-8" />
        <img className={teamPhoto} src={teamPhoto9} alt="team-9" />
        <img className={teamPhoto} src={teamPhoto10} alt="team-10" />
      </div>
    </Fade>
  )
}

export default TeamPhoto
